// extracted by mini-css-extract-plugin
module.exports = {"react-tel-input":"flags_react-tel-input__DNc6r"};